import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../../stores/newsfeed/actions';
// import { MentionsInput, Mention } from 'react-mentions';
// import MentionsInputStyle from './MentionsInputStyle';
// import { getHashTagsFromString } from '../../helperFuncs';
import { TextField, Card, CardHeader, FontIcon, CardText } from 'material-ui';
import MessageIcon from 'material-ui/svg-icons/communication/message';

class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      postMessage: '',
    };
  }

  render() {
    const {
      updateProp,
      closeExpandedArea,
      savingPost,
      hashtags,
      postMessage,
      expanded,
      onCardExpand,
    } = this.props;

    // const formatHashtags = hashtags.map(item => ({ id: item._id, display: item.hashtag }));

    return (
      expanded ?
        <div style={{ padding: '10px 12px', height: '150px', overflow: 'hidden' }} onClick={() => closeExpandedArea()}>
          <TextField
            id="postMessage"
            underlineShow={false}
            multiLine
            rowsMax={5}
            hintText="Type your message here"
            hintStyle={{ position: 'absolute', height: '95%', width: '97%' }}
            style={{ width: '100%' }}
            value={postMessage}
            onChange={({ target: { value } }) => updateProp({ postMessage: value })}
            textareaStyle={{ minHeight: '140px', height: '100%', marginTop: '-5px' }}
            disabled={savingPost}
          />
          {/* FOR HASHTAGS
            <MentionsInput
              value={this.state.postMessage}
              onChange={(event, newValue, newPlainTextValue) => {
                const hashes = getHashTagsFromString(newPlainTextValue);
                this.setState({ postMessage: newPlainTextValue });
                updateProp({ postMessage: newPlainTextValue, selectedHashtags: hashes });
              }}
              style={MentionsInputStyle}
              placeholder="Type your message here"
              disabled={savingPost}
            >
              <Mention trigger="#"
                data={formatHashtags}
                renderSuggestion={(suggestion, search, highlightedDisplay) => highlightedDisplay}
              />
            </MentionsInput>
          */}
        </div> :
        <Card
          expanded={expanded}
          onExpandChange={onCardExpand}
          style={{ boxShadow: 'none', marginBottom: '4px' }}
        >
          <CardHeader actAsExpander showExpandableButton textStyle={{ display: 'none' }}>
            <div>
              <FontIcon>
                <MessageIcon color={'rgba(0, 0, 0, 0.54)'} style={{ verticalAlign: 'bottom' }} />
                <span style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' }}>
                  Message
                </span>
              </FontIcon>
            </div>
          </CardHeader>
        </Card>
    );
  }
}

Message.propTypes = {
  updateProp: PropTypes.func,
  closeExpandedArea: PropTypes.func,
  savingPost: PropTypes.bool,
  hashtags: PropTypes.array,
  selectedHashtags: PropTypes.array,
  postMessage: PropTypes.string,
  expanded: PropTypes.bool,
  onCardExpand: PropTypes.func,
};

const mapStateToProps = ({ newsfeed }) => ({
  savingPost: newsfeed.get('savingPost'),
  hashtags: newsfeed.get('hashtags').toJS(),
  postMessage: newsfeed.get('postMessage'),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Message);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/message.jsx